/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as UnauthorizedImport } from './routes/unauthorized'
import { Route as LoginImport } from './routes/login'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated/route'
import { Route as AuthenticatedIndexImport } from './routes/_authenticated/index'
import { Route as AuthenticatedSettingsImport } from './routes/_authenticated/settings'
import { Route as AuthenticatedSearchImport } from './routes/_authenticated/search'
import { Route as AuthenticatedRolesImport } from './routes/_authenticated/roles'
import { Route as AuthenticatedProfilesImport } from './routes/_authenticated/profiles'
import { Route as AuthenticatedKioskImport } from './routes/_authenticated/kiosk'
import { Route as AuthenticatedDocumentsImport } from './routes/_authenticated/documents'
import { Route as AuthenticatedCollectionsImport } from './routes/_authenticated/collections'
import { Route as AuthenticatedAnalyticsImport } from './routes/_authenticated/analytics'
import { Route as AuthenticatedUsersRouteImport } from './routes/_authenticated/users/route'
import { Route as AuthenticatedUsersIndexImport } from './routes/_authenticated/users/index'
import { Route as AuthenticatedProfilesIndexImport } from './routes/_authenticated/profiles/index'
import { Route as AuthenticatedKioskIndexImport } from './routes/_authenticated/kiosk/index'
import { Route as AuthenticatedDocumentsIndexImport } from './routes/_authenticated/documents/index'
import { Route as AuthenticatedCollectionsIndexImport } from './routes/_authenticated/collections/index'
import { Route as AuthenticatedUsersAddImport } from './routes/_authenticated/users/add'
import { Route as AuthenticatedUsersIdImport } from './routes/_authenticated/users/$id'
import { Route as AuthenticatedProfilesAddImport } from './routes/_authenticated/profiles/add'
import { Route as AuthenticatedProfilesIdImport } from './routes/_authenticated/profiles/$id'
import { Route as AuthenticatedDocumentsAddImport } from './routes/_authenticated/documents/add'
import { Route as AuthenticatedDocumentsIdImport } from './routes/_authenticated/documents/$id'
import { Route as AuthenticatedCollectionsAddImport } from './routes/_authenticated/collections/add'
import { Route as AuthenticatedCollectionsIdImport } from './routes/_authenticated/collections/$id'
import { Route as AuthenticatedKioskSettingsIndexImport } from './routes/_authenticated/kiosk/settings/index'
import { Route as AuthenticatedKioskDevicesIndexImport } from './routes/_authenticated/kiosk/devices/index'
import { Route as AuthenticatedUsersEditIdImport } from './routes/_authenticated/users/edit/$id'
import { Route as AuthenticatedProfilesEditIdImport } from './routes/_authenticated/profiles/edit/$id'
import { Route as AuthenticatedKioskSettingsAddImport } from './routes/_authenticated/kiosk/settings/add'
import { Route as AuthenticatedKioskSettingsIdImport } from './routes/_authenticated/kiosk/settings/$id'
import { Route as AuthenticatedKioskPreviewIdImport } from './routes/_authenticated/kiosk/preview/$id'
import { Route as AuthenticatedKioskDevicesAddImport } from './routes/_authenticated/kiosk/devices/add'
import { Route as AuthenticatedKioskDevicesIdImport } from './routes/_authenticated/kiosk/devices/$id'
import { Route as AuthenticatedDocumentsEditIdImport } from './routes/_authenticated/documents/edit/$id'
import { Route as AuthenticatedCollectionsEditIdImport } from './routes/_authenticated/collections/edit/$id'
import { Route as AuthenticatedKioskSettingsEditIdImport } from './routes/_authenticated/kiosk/settings/edit/$id'
import { Route as AuthenticatedKioskDevicesEditIdImport } from './routes/_authenticated/kiosk/devices/edit/$id'

// Create/Update Routes

const UnauthorizedRoute = UnauthorizedImport.update({
  id: '/unauthorized',
  path: '/unauthorized',
  getParentRoute: () => rootRoute,
} as any)

const LoginRoute = LoginImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRoute,
} as any)

const AuthenticatedRouteRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRoute,
} as any)

const AuthenticatedIndexRoute = AuthenticatedIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)

const AuthenticatedSettingsRoute = AuthenticatedSettingsImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)

const AuthenticatedSearchRoute = AuthenticatedSearchImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)

const AuthenticatedRolesRoute = AuthenticatedRolesImport.update({
  id: '/roles',
  path: '/roles',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)

const AuthenticatedProfilesRoute = AuthenticatedProfilesImport.update({
  id: '/profiles',
  path: '/profiles',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)

const AuthenticatedKioskRoute = AuthenticatedKioskImport.update({
  id: '/kiosk',
  path: '/kiosk',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)

const AuthenticatedDocumentsRoute = AuthenticatedDocumentsImport.update({
  id: '/documents',
  path: '/documents',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)

const AuthenticatedCollectionsRoute = AuthenticatedCollectionsImport.update({
  id: '/collections',
  path: '/collections',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)

const AuthenticatedAnalyticsRoute = AuthenticatedAnalyticsImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)

const AuthenticatedUsersRouteRoute = AuthenticatedUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)

const AuthenticatedUsersIndexRoute = AuthenticatedUsersIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedUsersRouteRoute,
} as any)

const AuthenticatedProfilesIndexRoute = AuthenticatedProfilesIndexImport.update(
  {
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedProfilesRoute,
  } as any,
)

const AuthenticatedKioskIndexRoute = AuthenticatedKioskIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedKioskRoute,
} as any)

const AuthenticatedDocumentsIndexRoute =
  AuthenticatedDocumentsIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedDocumentsRoute,
  } as any)

const AuthenticatedCollectionsIndexRoute =
  AuthenticatedCollectionsIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedCollectionsRoute,
  } as any)

const AuthenticatedUsersAddRoute = AuthenticatedUsersAddImport.update({
  id: '/add',
  path: '/add',
  getParentRoute: () => AuthenticatedUsersRouteRoute,
} as any)

const AuthenticatedUsersIdRoute = AuthenticatedUsersIdImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AuthenticatedUsersRouteRoute,
} as any)

const AuthenticatedProfilesAddRoute = AuthenticatedProfilesAddImport.update({
  id: '/add',
  path: '/add',
  getParentRoute: () => AuthenticatedProfilesRoute,
} as any)

const AuthenticatedProfilesIdRoute = AuthenticatedProfilesIdImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AuthenticatedProfilesRoute,
} as any)

const AuthenticatedDocumentsAddRoute = AuthenticatedDocumentsAddImport.update({
  id: '/add',
  path: '/add',
  getParentRoute: () => AuthenticatedDocumentsRoute,
} as any)

const AuthenticatedDocumentsIdRoute = AuthenticatedDocumentsIdImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AuthenticatedDocumentsRoute,
} as any)

const AuthenticatedCollectionsAddRoute =
  AuthenticatedCollectionsAddImport.update({
    id: '/add',
    path: '/add',
    getParentRoute: () => AuthenticatedCollectionsRoute,
  } as any)

const AuthenticatedCollectionsIdRoute = AuthenticatedCollectionsIdImport.update(
  {
    id: '/$id',
    path: '/$id',
    getParentRoute: () => AuthenticatedCollectionsRoute,
  } as any,
)

const AuthenticatedKioskSettingsIndexRoute =
  AuthenticatedKioskSettingsIndexImport.update({
    id: '/settings/',
    path: '/settings/',
    getParentRoute: () => AuthenticatedKioskRoute,
  } as any)

const AuthenticatedKioskDevicesIndexRoute =
  AuthenticatedKioskDevicesIndexImport.update({
    id: '/devices/',
    path: '/devices/',
    getParentRoute: () => AuthenticatedKioskRoute,
  } as any)

const AuthenticatedUsersEditIdRoute = AuthenticatedUsersEditIdImport.update({
  id: '/edit/$id',
  path: '/edit/$id',
  getParentRoute: () => AuthenticatedUsersRouteRoute,
} as any)

const AuthenticatedProfilesEditIdRoute =
  AuthenticatedProfilesEditIdImport.update({
    id: '/edit/$id',
    path: '/edit/$id',
    getParentRoute: () => AuthenticatedProfilesRoute,
  } as any)

const AuthenticatedKioskSettingsAddRoute =
  AuthenticatedKioskSettingsAddImport.update({
    id: '/settings/add',
    path: '/settings/add',
    getParentRoute: () => AuthenticatedKioskRoute,
  } as any)

const AuthenticatedKioskSettingsIdRoute =
  AuthenticatedKioskSettingsIdImport.update({
    id: '/settings/$id',
    path: '/settings/$id',
    getParentRoute: () => AuthenticatedKioskRoute,
  } as any)

const AuthenticatedKioskPreviewIdRoute =
  AuthenticatedKioskPreviewIdImport.update({
    id: '/preview/$id',
    path: '/preview/$id',
    getParentRoute: () => AuthenticatedKioskRoute,
  } as any)

const AuthenticatedKioskDevicesAddRoute =
  AuthenticatedKioskDevicesAddImport.update({
    id: '/devices/add',
    path: '/devices/add',
    getParentRoute: () => AuthenticatedKioskRoute,
  } as any)

const AuthenticatedKioskDevicesIdRoute =
  AuthenticatedKioskDevicesIdImport.update({
    id: '/devices/$id',
    path: '/devices/$id',
    getParentRoute: () => AuthenticatedKioskRoute,
  } as any)

const AuthenticatedDocumentsEditIdRoute =
  AuthenticatedDocumentsEditIdImport.update({
    id: '/edit/$id',
    path: '/edit/$id',
    getParentRoute: () => AuthenticatedDocumentsRoute,
  } as any)

const AuthenticatedCollectionsEditIdRoute =
  AuthenticatedCollectionsEditIdImport.update({
    id: '/edit/$id',
    path: '/edit/$id',
    getParentRoute: () => AuthenticatedCollectionsRoute,
  } as any)

const AuthenticatedKioskSettingsEditIdRoute =
  AuthenticatedKioskSettingsEditIdImport.update({
    id: '/settings/edit/$id',
    path: '/settings/edit/$id',
    getParentRoute: () => AuthenticatedKioskRoute,
  } as any)

const AuthenticatedKioskDevicesEditIdRoute =
  AuthenticatedKioskDevicesEditIdImport.update({
    id: '/devices/edit/$id',
    path: '/devices/edit/$id',
    getParentRoute: () => AuthenticatedKioskRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRoute
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginImport
      parentRoute: typeof rootRoute
    }
    '/unauthorized': {
      id: '/unauthorized'
      path: '/unauthorized'
      fullPath: '/unauthorized'
      preLoaderRoute: typeof UnauthorizedImport
      parentRoute: typeof rootRoute
    }
    '/_authenticated/users': {
      id: '/_authenticated/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof AuthenticatedUsersRouteImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/analytics': {
      id: '/_authenticated/analytics'
      path: '/analytics'
      fullPath: '/analytics'
      preLoaderRoute: typeof AuthenticatedAnalyticsImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/collections': {
      id: '/_authenticated/collections'
      path: '/collections'
      fullPath: '/collections'
      preLoaderRoute: typeof AuthenticatedCollectionsImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/documents': {
      id: '/_authenticated/documents'
      path: '/documents'
      fullPath: '/documents'
      preLoaderRoute: typeof AuthenticatedDocumentsImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/kiosk': {
      id: '/_authenticated/kiosk'
      path: '/kiosk'
      fullPath: '/kiosk'
      preLoaderRoute: typeof AuthenticatedKioskImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/profiles': {
      id: '/_authenticated/profiles'
      path: '/profiles'
      fullPath: '/profiles'
      preLoaderRoute: typeof AuthenticatedProfilesImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/roles': {
      id: '/_authenticated/roles'
      path: '/roles'
      fullPath: '/roles'
      preLoaderRoute: typeof AuthenticatedRolesImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/search': {
      id: '/_authenticated/search'
      path: '/search'
      fullPath: '/search'
      preLoaderRoute: typeof AuthenticatedSearchImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/settings': {
      id: '/_authenticated/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexImport
      parentRoute: typeof AuthenticatedRouteImport
    }
    '/_authenticated/collections/$id': {
      id: '/_authenticated/collections/$id'
      path: '/$id'
      fullPath: '/collections/$id'
      preLoaderRoute: typeof AuthenticatedCollectionsIdImport
      parentRoute: typeof AuthenticatedCollectionsImport
    }
    '/_authenticated/collections/add': {
      id: '/_authenticated/collections/add'
      path: '/add'
      fullPath: '/collections/add'
      preLoaderRoute: typeof AuthenticatedCollectionsAddImport
      parentRoute: typeof AuthenticatedCollectionsImport
    }
    '/_authenticated/documents/$id': {
      id: '/_authenticated/documents/$id'
      path: '/$id'
      fullPath: '/documents/$id'
      preLoaderRoute: typeof AuthenticatedDocumentsIdImport
      parentRoute: typeof AuthenticatedDocumentsImport
    }
    '/_authenticated/documents/add': {
      id: '/_authenticated/documents/add'
      path: '/add'
      fullPath: '/documents/add'
      preLoaderRoute: typeof AuthenticatedDocumentsAddImport
      parentRoute: typeof AuthenticatedDocumentsImport
    }
    '/_authenticated/profiles/$id': {
      id: '/_authenticated/profiles/$id'
      path: '/$id'
      fullPath: '/profiles/$id'
      preLoaderRoute: typeof AuthenticatedProfilesIdImport
      parentRoute: typeof AuthenticatedProfilesImport
    }
    '/_authenticated/profiles/add': {
      id: '/_authenticated/profiles/add'
      path: '/add'
      fullPath: '/profiles/add'
      preLoaderRoute: typeof AuthenticatedProfilesAddImport
      parentRoute: typeof AuthenticatedProfilesImport
    }
    '/_authenticated/users/$id': {
      id: '/_authenticated/users/$id'
      path: '/$id'
      fullPath: '/users/$id'
      preLoaderRoute: typeof AuthenticatedUsersIdImport
      parentRoute: typeof AuthenticatedUsersRouteImport
    }
    '/_authenticated/users/add': {
      id: '/_authenticated/users/add'
      path: '/add'
      fullPath: '/users/add'
      preLoaderRoute: typeof AuthenticatedUsersAddImport
      parentRoute: typeof AuthenticatedUsersRouteImport
    }
    '/_authenticated/collections/': {
      id: '/_authenticated/collections/'
      path: '/'
      fullPath: '/collections/'
      preLoaderRoute: typeof AuthenticatedCollectionsIndexImport
      parentRoute: typeof AuthenticatedCollectionsImport
    }
    '/_authenticated/documents/': {
      id: '/_authenticated/documents/'
      path: '/'
      fullPath: '/documents/'
      preLoaderRoute: typeof AuthenticatedDocumentsIndexImport
      parentRoute: typeof AuthenticatedDocumentsImport
    }
    '/_authenticated/kiosk/': {
      id: '/_authenticated/kiosk/'
      path: '/'
      fullPath: '/kiosk/'
      preLoaderRoute: typeof AuthenticatedKioskIndexImport
      parentRoute: typeof AuthenticatedKioskImport
    }
    '/_authenticated/profiles/': {
      id: '/_authenticated/profiles/'
      path: '/'
      fullPath: '/profiles/'
      preLoaderRoute: typeof AuthenticatedProfilesIndexImport
      parentRoute: typeof AuthenticatedProfilesImport
    }
    '/_authenticated/users/': {
      id: '/_authenticated/users/'
      path: '/'
      fullPath: '/users/'
      preLoaderRoute: typeof AuthenticatedUsersIndexImport
      parentRoute: typeof AuthenticatedUsersRouteImport
    }
    '/_authenticated/collections/edit/$id': {
      id: '/_authenticated/collections/edit/$id'
      path: '/edit/$id'
      fullPath: '/collections/edit/$id'
      preLoaderRoute: typeof AuthenticatedCollectionsEditIdImport
      parentRoute: typeof AuthenticatedCollectionsImport
    }
    '/_authenticated/documents/edit/$id': {
      id: '/_authenticated/documents/edit/$id'
      path: '/edit/$id'
      fullPath: '/documents/edit/$id'
      preLoaderRoute: typeof AuthenticatedDocumentsEditIdImport
      parentRoute: typeof AuthenticatedDocumentsImport
    }
    '/_authenticated/kiosk/devices/$id': {
      id: '/_authenticated/kiosk/devices/$id'
      path: '/devices/$id'
      fullPath: '/kiosk/devices/$id'
      preLoaderRoute: typeof AuthenticatedKioskDevicesIdImport
      parentRoute: typeof AuthenticatedKioskImport
    }
    '/_authenticated/kiosk/devices/add': {
      id: '/_authenticated/kiosk/devices/add'
      path: '/devices/add'
      fullPath: '/kiosk/devices/add'
      preLoaderRoute: typeof AuthenticatedKioskDevicesAddImport
      parentRoute: typeof AuthenticatedKioskImport
    }
    '/_authenticated/kiosk/preview/$id': {
      id: '/_authenticated/kiosk/preview/$id'
      path: '/preview/$id'
      fullPath: '/kiosk/preview/$id'
      preLoaderRoute: typeof AuthenticatedKioskPreviewIdImport
      parentRoute: typeof AuthenticatedKioskImport
    }
    '/_authenticated/kiosk/settings/$id': {
      id: '/_authenticated/kiosk/settings/$id'
      path: '/settings/$id'
      fullPath: '/kiosk/settings/$id'
      preLoaderRoute: typeof AuthenticatedKioskSettingsIdImport
      parentRoute: typeof AuthenticatedKioskImport
    }
    '/_authenticated/kiosk/settings/add': {
      id: '/_authenticated/kiosk/settings/add'
      path: '/settings/add'
      fullPath: '/kiosk/settings/add'
      preLoaderRoute: typeof AuthenticatedKioskSettingsAddImport
      parentRoute: typeof AuthenticatedKioskImport
    }
    '/_authenticated/profiles/edit/$id': {
      id: '/_authenticated/profiles/edit/$id'
      path: '/edit/$id'
      fullPath: '/profiles/edit/$id'
      preLoaderRoute: typeof AuthenticatedProfilesEditIdImport
      parentRoute: typeof AuthenticatedProfilesImport
    }
    '/_authenticated/users/edit/$id': {
      id: '/_authenticated/users/edit/$id'
      path: '/edit/$id'
      fullPath: '/users/edit/$id'
      preLoaderRoute: typeof AuthenticatedUsersEditIdImport
      parentRoute: typeof AuthenticatedUsersRouteImport
    }
    '/_authenticated/kiosk/devices/': {
      id: '/_authenticated/kiosk/devices/'
      path: '/devices'
      fullPath: '/kiosk/devices'
      preLoaderRoute: typeof AuthenticatedKioskDevicesIndexImport
      parentRoute: typeof AuthenticatedKioskImport
    }
    '/_authenticated/kiosk/settings/': {
      id: '/_authenticated/kiosk/settings/'
      path: '/settings'
      fullPath: '/kiosk/settings'
      preLoaderRoute: typeof AuthenticatedKioskSettingsIndexImport
      parentRoute: typeof AuthenticatedKioskImport
    }
    '/_authenticated/kiosk/devices/edit/$id': {
      id: '/_authenticated/kiosk/devices/edit/$id'
      path: '/devices/edit/$id'
      fullPath: '/kiosk/devices/edit/$id'
      preLoaderRoute: typeof AuthenticatedKioskDevicesEditIdImport
      parentRoute: typeof AuthenticatedKioskImport
    }
    '/_authenticated/kiosk/settings/edit/$id': {
      id: '/_authenticated/kiosk/settings/edit/$id'
      path: '/settings/edit/$id'
      fullPath: '/kiosk/settings/edit/$id'
      preLoaderRoute: typeof AuthenticatedKioskSettingsEditIdImport
      parentRoute: typeof AuthenticatedKioskImport
    }
  }
}

// Create and export the route tree

interface AuthenticatedUsersRouteRouteChildren {
  AuthenticatedUsersIdRoute: typeof AuthenticatedUsersIdRoute
  AuthenticatedUsersAddRoute: typeof AuthenticatedUsersAddRoute
  AuthenticatedUsersIndexRoute: typeof AuthenticatedUsersIndexRoute
  AuthenticatedUsersEditIdRoute: typeof AuthenticatedUsersEditIdRoute
}

const AuthenticatedUsersRouteRouteChildren: AuthenticatedUsersRouteRouteChildren =
  {
    AuthenticatedUsersIdRoute: AuthenticatedUsersIdRoute,
    AuthenticatedUsersAddRoute: AuthenticatedUsersAddRoute,
    AuthenticatedUsersIndexRoute: AuthenticatedUsersIndexRoute,
    AuthenticatedUsersEditIdRoute: AuthenticatedUsersEditIdRoute,
  }

const AuthenticatedUsersRouteRouteWithChildren =
  AuthenticatedUsersRouteRoute._addFileChildren(
    AuthenticatedUsersRouteRouteChildren,
  )

interface AuthenticatedCollectionsRouteChildren {
  AuthenticatedCollectionsIdRoute: typeof AuthenticatedCollectionsIdRoute
  AuthenticatedCollectionsAddRoute: typeof AuthenticatedCollectionsAddRoute
  AuthenticatedCollectionsIndexRoute: typeof AuthenticatedCollectionsIndexRoute
  AuthenticatedCollectionsEditIdRoute: typeof AuthenticatedCollectionsEditIdRoute
}

const AuthenticatedCollectionsRouteChildren: AuthenticatedCollectionsRouteChildren =
  {
    AuthenticatedCollectionsIdRoute: AuthenticatedCollectionsIdRoute,
    AuthenticatedCollectionsAddRoute: AuthenticatedCollectionsAddRoute,
    AuthenticatedCollectionsIndexRoute: AuthenticatedCollectionsIndexRoute,
    AuthenticatedCollectionsEditIdRoute: AuthenticatedCollectionsEditIdRoute,
  }

const AuthenticatedCollectionsRouteWithChildren =
  AuthenticatedCollectionsRoute._addFileChildren(
    AuthenticatedCollectionsRouteChildren,
  )

interface AuthenticatedDocumentsRouteChildren {
  AuthenticatedDocumentsIdRoute: typeof AuthenticatedDocumentsIdRoute
  AuthenticatedDocumentsAddRoute: typeof AuthenticatedDocumentsAddRoute
  AuthenticatedDocumentsIndexRoute: typeof AuthenticatedDocumentsIndexRoute
  AuthenticatedDocumentsEditIdRoute: typeof AuthenticatedDocumentsEditIdRoute
}

const AuthenticatedDocumentsRouteChildren: AuthenticatedDocumentsRouteChildren =
  {
    AuthenticatedDocumentsIdRoute: AuthenticatedDocumentsIdRoute,
    AuthenticatedDocumentsAddRoute: AuthenticatedDocumentsAddRoute,
    AuthenticatedDocumentsIndexRoute: AuthenticatedDocumentsIndexRoute,
    AuthenticatedDocumentsEditIdRoute: AuthenticatedDocumentsEditIdRoute,
  }

const AuthenticatedDocumentsRouteWithChildren =
  AuthenticatedDocumentsRoute._addFileChildren(
    AuthenticatedDocumentsRouteChildren,
  )

interface AuthenticatedKioskRouteChildren {
  AuthenticatedKioskIndexRoute: typeof AuthenticatedKioskIndexRoute
  AuthenticatedKioskDevicesIdRoute: typeof AuthenticatedKioskDevicesIdRoute
  AuthenticatedKioskDevicesAddRoute: typeof AuthenticatedKioskDevicesAddRoute
  AuthenticatedKioskPreviewIdRoute: typeof AuthenticatedKioskPreviewIdRoute
  AuthenticatedKioskSettingsIdRoute: typeof AuthenticatedKioskSettingsIdRoute
  AuthenticatedKioskSettingsAddRoute: typeof AuthenticatedKioskSettingsAddRoute
  AuthenticatedKioskDevicesIndexRoute: typeof AuthenticatedKioskDevicesIndexRoute
  AuthenticatedKioskSettingsIndexRoute: typeof AuthenticatedKioskSettingsIndexRoute
  AuthenticatedKioskDevicesEditIdRoute: typeof AuthenticatedKioskDevicesEditIdRoute
  AuthenticatedKioskSettingsEditIdRoute: typeof AuthenticatedKioskSettingsEditIdRoute
}

const AuthenticatedKioskRouteChildren: AuthenticatedKioskRouteChildren = {
  AuthenticatedKioskIndexRoute: AuthenticatedKioskIndexRoute,
  AuthenticatedKioskDevicesIdRoute: AuthenticatedKioskDevicesIdRoute,
  AuthenticatedKioskDevicesAddRoute: AuthenticatedKioskDevicesAddRoute,
  AuthenticatedKioskPreviewIdRoute: AuthenticatedKioskPreviewIdRoute,
  AuthenticatedKioskSettingsIdRoute: AuthenticatedKioskSettingsIdRoute,
  AuthenticatedKioskSettingsAddRoute: AuthenticatedKioskSettingsAddRoute,
  AuthenticatedKioskDevicesIndexRoute: AuthenticatedKioskDevicesIndexRoute,
  AuthenticatedKioskSettingsIndexRoute: AuthenticatedKioskSettingsIndexRoute,
  AuthenticatedKioskDevicesEditIdRoute: AuthenticatedKioskDevicesEditIdRoute,
  AuthenticatedKioskSettingsEditIdRoute: AuthenticatedKioskSettingsEditIdRoute,
}

const AuthenticatedKioskRouteWithChildren =
  AuthenticatedKioskRoute._addFileChildren(AuthenticatedKioskRouteChildren)

interface AuthenticatedProfilesRouteChildren {
  AuthenticatedProfilesIdRoute: typeof AuthenticatedProfilesIdRoute
  AuthenticatedProfilesAddRoute: typeof AuthenticatedProfilesAddRoute
  AuthenticatedProfilesIndexRoute: typeof AuthenticatedProfilesIndexRoute
  AuthenticatedProfilesEditIdRoute: typeof AuthenticatedProfilesEditIdRoute
}

const AuthenticatedProfilesRouteChildren: AuthenticatedProfilesRouteChildren = {
  AuthenticatedProfilesIdRoute: AuthenticatedProfilesIdRoute,
  AuthenticatedProfilesAddRoute: AuthenticatedProfilesAddRoute,
  AuthenticatedProfilesIndexRoute: AuthenticatedProfilesIndexRoute,
  AuthenticatedProfilesEditIdRoute: AuthenticatedProfilesEditIdRoute,
}

const AuthenticatedProfilesRouteWithChildren =
  AuthenticatedProfilesRoute._addFileChildren(
    AuthenticatedProfilesRouteChildren,
  )

interface AuthenticatedRouteRouteChildren {
  AuthenticatedUsersRouteRoute: typeof AuthenticatedUsersRouteRouteWithChildren
  AuthenticatedAnalyticsRoute: typeof AuthenticatedAnalyticsRoute
  AuthenticatedCollectionsRoute: typeof AuthenticatedCollectionsRouteWithChildren
  AuthenticatedDocumentsRoute: typeof AuthenticatedDocumentsRouteWithChildren
  AuthenticatedKioskRoute: typeof AuthenticatedKioskRouteWithChildren
  AuthenticatedProfilesRoute: typeof AuthenticatedProfilesRouteWithChildren
  AuthenticatedRolesRoute: typeof AuthenticatedRolesRoute
  AuthenticatedSearchRoute: typeof AuthenticatedSearchRoute
  AuthenticatedSettingsRoute: typeof AuthenticatedSettingsRoute
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedUsersRouteRoute: AuthenticatedUsersRouteRouteWithChildren,
  AuthenticatedAnalyticsRoute: AuthenticatedAnalyticsRoute,
  AuthenticatedCollectionsRoute: AuthenticatedCollectionsRouteWithChildren,
  AuthenticatedDocumentsRoute: AuthenticatedDocumentsRouteWithChildren,
  AuthenticatedKioskRoute: AuthenticatedKioskRouteWithChildren,
  AuthenticatedProfilesRoute: AuthenticatedProfilesRouteWithChildren,
  AuthenticatedRolesRoute: AuthenticatedRolesRoute,
  AuthenticatedSearchRoute: AuthenticatedSearchRoute,
  AuthenticatedSettingsRoute: AuthenticatedSettingsRoute,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
}

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

export interface FileRoutesByFullPath {
  '': typeof AuthenticatedRouteRouteWithChildren
  '/login': typeof LoginRoute
  '/unauthorized': typeof UnauthorizedRoute
  '/users': typeof AuthenticatedUsersRouteRouteWithChildren
  '/analytics': typeof AuthenticatedAnalyticsRoute
  '/collections': typeof AuthenticatedCollectionsRouteWithChildren
  '/documents': typeof AuthenticatedDocumentsRouteWithChildren
  '/kiosk': typeof AuthenticatedKioskRouteWithChildren
  '/profiles': typeof AuthenticatedProfilesRouteWithChildren
  '/roles': typeof AuthenticatedRolesRoute
  '/search': typeof AuthenticatedSearchRoute
  '/settings': typeof AuthenticatedSettingsRoute
  '/': typeof AuthenticatedIndexRoute
  '/collections/$id': typeof AuthenticatedCollectionsIdRoute
  '/collections/add': typeof AuthenticatedCollectionsAddRoute
  '/documents/$id': typeof AuthenticatedDocumentsIdRoute
  '/documents/add': typeof AuthenticatedDocumentsAddRoute
  '/profiles/$id': typeof AuthenticatedProfilesIdRoute
  '/profiles/add': typeof AuthenticatedProfilesAddRoute
  '/users/$id': typeof AuthenticatedUsersIdRoute
  '/users/add': typeof AuthenticatedUsersAddRoute
  '/collections/': typeof AuthenticatedCollectionsIndexRoute
  '/documents/': typeof AuthenticatedDocumentsIndexRoute
  '/kiosk/': typeof AuthenticatedKioskIndexRoute
  '/profiles/': typeof AuthenticatedProfilesIndexRoute
  '/users/': typeof AuthenticatedUsersIndexRoute
  '/collections/edit/$id': typeof AuthenticatedCollectionsEditIdRoute
  '/documents/edit/$id': typeof AuthenticatedDocumentsEditIdRoute
  '/kiosk/devices/$id': typeof AuthenticatedKioskDevicesIdRoute
  '/kiosk/devices/add': typeof AuthenticatedKioskDevicesAddRoute
  '/kiosk/preview/$id': typeof AuthenticatedKioskPreviewIdRoute
  '/kiosk/settings/$id': typeof AuthenticatedKioskSettingsIdRoute
  '/kiosk/settings/add': typeof AuthenticatedKioskSettingsAddRoute
  '/profiles/edit/$id': typeof AuthenticatedProfilesEditIdRoute
  '/users/edit/$id': typeof AuthenticatedUsersEditIdRoute
  '/kiosk/devices': typeof AuthenticatedKioskDevicesIndexRoute
  '/kiosk/settings': typeof AuthenticatedKioskSettingsIndexRoute
  '/kiosk/devices/edit/$id': typeof AuthenticatedKioskDevicesEditIdRoute
  '/kiosk/settings/edit/$id': typeof AuthenticatedKioskSettingsEditIdRoute
}

export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/unauthorized': typeof UnauthorizedRoute
  '/analytics': typeof AuthenticatedAnalyticsRoute
  '/roles': typeof AuthenticatedRolesRoute
  '/search': typeof AuthenticatedSearchRoute
  '/settings': typeof AuthenticatedSettingsRoute
  '/': typeof AuthenticatedIndexRoute
  '/collections/$id': typeof AuthenticatedCollectionsIdRoute
  '/collections/add': typeof AuthenticatedCollectionsAddRoute
  '/documents/$id': typeof AuthenticatedDocumentsIdRoute
  '/documents/add': typeof AuthenticatedDocumentsAddRoute
  '/profiles/$id': typeof AuthenticatedProfilesIdRoute
  '/profiles/add': typeof AuthenticatedProfilesAddRoute
  '/users/$id': typeof AuthenticatedUsersIdRoute
  '/users/add': typeof AuthenticatedUsersAddRoute
  '/collections': typeof AuthenticatedCollectionsIndexRoute
  '/documents': typeof AuthenticatedDocumentsIndexRoute
  '/kiosk': typeof AuthenticatedKioskIndexRoute
  '/profiles': typeof AuthenticatedProfilesIndexRoute
  '/users': typeof AuthenticatedUsersIndexRoute
  '/collections/edit/$id': typeof AuthenticatedCollectionsEditIdRoute
  '/documents/edit/$id': typeof AuthenticatedDocumentsEditIdRoute
  '/kiosk/devices/$id': typeof AuthenticatedKioskDevicesIdRoute
  '/kiosk/devices/add': typeof AuthenticatedKioskDevicesAddRoute
  '/kiosk/preview/$id': typeof AuthenticatedKioskPreviewIdRoute
  '/kiosk/settings/$id': typeof AuthenticatedKioskSettingsIdRoute
  '/kiosk/settings/add': typeof AuthenticatedKioskSettingsAddRoute
  '/profiles/edit/$id': typeof AuthenticatedProfilesEditIdRoute
  '/users/edit/$id': typeof AuthenticatedUsersEditIdRoute
  '/kiosk/devices': typeof AuthenticatedKioskDevicesIndexRoute
  '/kiosk/settings': typeof AuthenticatedKioskSettingsIndexRoute
  '/kiosk/devices/edit/$id': typeof AuthenticatedKioskDevicesEditIdRoute
  '/kiosk/settings/edit/$id': typeof AuthenticatedKioskSettingsEditIdRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/_authenticated': typeof AuthenticatedRouteRouteWithChildren
  '/login': typeof LoginRoute
  '/unauthorized': typeof UnauthorizedRoute
  '/_authenticated/users': typeof AuthenticatedUsersRouteRouteWithChildren
  '/_authenticated/analytics': typeof AuthenticatedAnalyticsRoute
  '/_authenticated/collections': typeof AuthenticatedCollectionsRouteWithChildren
  '/_authenticated/documents': typeof AuthenticatedDocumentsRouteWithChildren
  '/_authenticated/kiosk': typeof AuthenticatedKioskRouteWithChildren
  '/_authenticated/profiles': typeof AuthenticatedProfilesRouteWithChildren
  '/_authenticated/roles': typeof AuthenticatedRolesRoute
  '/_authenticated/search': typeof AuthenticatedSearchRoute
  '/_authenticated/settings': typeof AuthenticatedSettingsRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/collections/$id': typeof AuthenticatedCollectionsIdRoute
  '/_authenticated/collections/add': typeof AuthenticatedCollectionsAddRoute
  '/_authenticated/documents/$id': typeof AuthenticatedDocumentsIdRoute
  '/_authenticated/documents/add': typeof AuthenticatedDocumentsAddRoute
  '/_authenticated/profiles/$id': typeof AuthenticatedProfilesIdRoute
  '/_authenticated/profiles/add': typeof AuthenticatedProfilesAddRoute
  '/_authenticated/users/$id': typeof AuthenticatedUsersIdRoute
  '/_authenticated/users/add': typeof AuthenticatedUsersAddRoute
  '/_authenticated/collections/': typeof AuthenticatedCollectionsIndexRoute
  '/_authenticated/documents/': typeof AuthenticatedDocumentsIndexRoute
  '/_authenticated/kiosk/': typeof AuthenticatedKioskIndexRoute
  '/_authenticated/profiles/': typeof AuthenticatedProfilesIndexRoute
  '/_authenticated/users/': typeof AuthenticatedUsersIndexRoute
  '/_authenticated/collections/edit/$id': typeof AuthenticatedCollectionsEditIdRoute
  '/_authenticated/documents/edit/$id': typeof AuthenticatedDocumentsEditIdRoute
  '/_authenticated/kiosk/devices/$id': typeof AuthenticatedKioskDevicesIdRoute
  '/_authenticated/kiosk/devices/add': typeof AuthenticatedKioskDevicesAddRoute
  '/_authenticated/kiosk/preview/$id': typeof AuthenticatedKioskPreviewIdRoute
  '/_authenticated/kiosk/settings/$id': typeof AuthenticatedKioskSettingsIdRoute
  '/_authenticated/kiosk/settings/add': typeof AuthenticatedKioskSettingsAddRoute
  '/_authenticated/profiles/edit/$id': typeof AuthenticatedProfilesEditIdRoute
  '/_authenticated/users/edit/$id': typeof AuthenticatedUsersEditIdRoute
  '/_authenticated/kiosk/devices/': typeof AuthenticatedKioskDevicesIndexRoute
  '/_authenticated/kiosk/settings/': typeof AuthenticatedKioskSettingsIndexRoute
  '/_authenticated/kiosk/devices/edit/$id': typeof AuthenticatedKioskDevicesEditIdRoute
  '/_authenticated/kiosk/settings/edit/$id': typeof AuthenticatedKioskSettingsEditIdRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | ''
    | '/login'
    | '/unauthorized'
    | '/users'
    | '/analytics'
    | '/collections'
    | '/documents'
    | '/kiosk'
    | '/profiles'
    | '/roles'
    | '/search'
    | '/settings'
    | '/'
    | '/collections/$id'
    | '/collections/add'
    | '/documents/$id'
    | '/documents/add'
    | '/profiles/$id'
    | '/profiles/add'
    | '/users/$id'
    | '/users/add'
    | '/collections/'
    | '/documents/'
    | '/kiosk/'
    | '/profiles/'
    | '/users/'
    | '/collections/edit/$id'
    | '/documents/edit/$id'
    | '/kiosk/devices/$id'
    | '/kiosk/devices/add'
    | '/kiosk/preview/$id'
    | '/kiosk/settings/$id'
    | '/kiosk/settings/add'
    | '/profiles/edit/$id'
    | '/users/edit/$id'
    | '/kiosk/devices'
    | '/kiosk/settings'
    | '/kiosk/devices/edit/$id'
    | '/kiosk/settings/edit/$id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/unauthorized'
    | '/analytics'
    | '/roles'
    | '/search'
    | '/settings'
    | '/'
    | '/collections/$id'
    | '/collections/add'
    | '/documents/$id'
    | '/documents/add'
    | '/profiles/$id'
    | '/profiles/add'
    | '/users/$id'
    | '/users/add'
    | '/collections'
    | '/documents'
    | '/kiosk'
    | '/profiles'
    | '/users'
    | '/collections/edit/$id'
    | '/documents/edit/$id'
    | '/kiosk/devices/$id'
    | '/kiosk/devices/add'
    | '/kiosk/preview/$id'
    | '/kiosk/settings/$id'
    | '/kiosk/settings/add'
    | '/profiles/edit/$id'
    | '/users/edit/$id'
    | '/kiosk/devices'
    | '/kiosk/settings'
    | '/kiosk/devices/edit/$id'
    | '/kiosk/settings/edit/$id'
  id:
    | '__root__'
    | '/_authenticated'
    | '/login'
    | '/unauthorized'
    | '/_authenticated/users'
    | '/_authenticated/analytics'
    | '/_authenticated/collections'
    | '/_authenticated/documents'
    | '/_authenticated/kiosk'
    | '/_authenticated/profiles'
    | '/_authenticated/roles'
    | '/_authenticated/search'
    | '/_authenticated/settings'
    | '/_authenticated/'
    | '/_authenticated/collections/$id'
    | '/_authenticated/collections/add'
    | '/_authenticated/documents/$id'
    | '/_authenticated/documents/add'
    | '/_authenticated/profiles/$id'
    | '/_authenticated/profiles/add'
    | '/_authenticated/users/$id'
    | '/_authenticated/users/add'
    | '/_authenticated/collections/'
    | '/_authenticated/documents/'
    | '/_authenticated/kiosk/'
    | '/_authenticated/profiles/'
    | '/_authenticated/users/'
    | '/_authenticated/collections/edit/$id'
    | '/_authenticated/documents/edit/$id'
    | '/_authenticated/kiosk/devices/$id'
    | '/_authenticated/kiosk/devices/add'
    | '/_authenticated/kiosk/preview/$id'
    | '/_authenticated/kiosk/settings/$id'
    | '/_authenticated/kiosk/settings/add'
    | '/_authenticated/profiles/edit/$id'
    | '/_authenticated/users/edit/$id'
    | '/_authenticated/kiosk/devices/'
    | '/_authenticated/kiosk/settings/'
    | '/_authenticated/kiosk/devices/edit/$id'
    | '/_authenticated/kiosk/settings/edit/$id'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren
  LoginRoute: typeof LoginRoute
  UnauthorizedRoute: typeof UnauthorizedRoute
}

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
  LoginRoute: LoginRoute,
  UnauthorizedRoute: UnauthorizedRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/_authenticated",
        "/login",
        "/unauthorized"
      ]
    },
    "/_authenticated": {
      "filePath": "_authenticated/route.tsx",
      "children": [
        "/_authenticated/users",
        "/_authenticated/analytics",
        "/_authenticated/collections",
        "/_authenticated/documents",
        "/_authenticated/kiosk",
        "/_authenticated/profiles",
        "/_authenticated/roles",
        "/_authenticated/search",
        "/_authenticated/settings",
        "/_authenticated/"
      ]
    },
    "/login": {
      "filePath": "login.tsx"
    },
    "/unauthorized": {
      "filePath": "unauthorized.tsx"
    },
    "/_authenticated/users": {
      "filePath": "_authenticated/users/route.tsx",
      "parent": "/_authenticated",
      "children": [
        "/_authenticated/users/$id",
        "/_authenticated/users/add",
        "/_authenticated/users/",
        "/_authenticated/users/edit/$id"
      ]
    },
    "/_authenticated/analytics": {
      "filePath": "_authenticated/analytics.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/collections": {
      "filePath": "_authenticated/collections.tsx",
      "parent": "/_authenticated",
      "children": [
        "/_authenticated/collections/$id",
        "/_authenticated/collections/add",
        "/_authenticated/collections/",
        "/_authenticated/collections/edit/$id"
      ]
    },
    "/_authenticated/documents": {
      "filePath": "_authenticated/documents.tsx",
      "parent": "/_authenticated",
      "children": [
        "/_authenticated/documents/$id",
        "/_authenticated/documents/add",
        "/_authenticated/documents/",
        "/_authenticated/documents/edit/$id"
      ]
    },
    "/_authenticated/kiosk": {
      "filePath": "_authenticated/kiosk.tsx",
      "parent": "/_authenticated",
      "children": [
        "/_authenticated/kiosk/",
        "/_authenticated/kiosk/devices/$id",
        "/_authenticated/kiosk/devices/add",
        "/_authenticated/kiosk/preview/$id",
        "/_authenticated/kiosk/settings/$id",
        "/_authenticated/kiosk/settings/add",
        "/_authenticated/kiosk/devices/",
        "/_authenticated/kiosk/settings/",
        "/_authenticated/kiosk/devices/edit/$id",
        "/_authenticated/kiosk/settings/edit/$id"
      ]
    },
    "/_authenticated/profiles": {
      "filePath": "_authenticated/profiles.tsx",
      "parent": "/_authenticated",
      "children": [
        "/_authenticated/profiles/$id",
        "/_authenticated/profiles/add",
        "/_authenticated/profiles/",
        "/_authenticated/profiles/edit/$id"
      ]
    },
    "/_authenticated/roles": {
      "filePath": "_authenticated/roles.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/search": {
      "filePath": "_authenticated/search.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/settings": {
      "filePath": "_authenticated/settings.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/": {
      "filePath": "_authenticated/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/collections/$id": {
      "filePath": "_authenticated/collections/$id.tsx",
      "parent": "/_authenticated/collections"
    },
    "/_authenticated/collections/add": {
      "filePath": "_authenticated/collections/add.tsx",
      "parent": "/_authenticated/collections"
    },
    "/_authenticated/documents/$id": {
      "filePath": "_authenticated/documents/$id.tsx",
      "parent": "/_authenticated/documents"
    },
    "/_authenticated/documents/add": {
      "filePath": "_authenticated/documents/add.tsx",
      "parent": "/_authenticated/documents"
    },
    "/_authenticated/profiles/$id": {
      "filePath": "_authenticated/profiles/$id.tsx",
      "parent": "/_authenticated/profiles"
    },
    "/_authenticated/profiles/add": {
      "filePath": "_authenticated/profiles/add.tsx",
      "parent": "/_authenticated/profiles"
    },
    "/_authenticated/users/$id": {
      "filePath": "_authenticated/users/$id.tsx",
      "parent": "/_authenticated/users"
    },
    "/_authenticated/users/add": {
      "filePath": "_authenticated/users/add.tsx",
      "parent": "/_authenticated/users"
    },
    "/_authenticated/collections/": {
      "filePath": "_authenticated/collections/index.tsx",
      "parent": "/_authenticated/collections"
    },
    "/_authenticated/documents/": {
      "filePath": "_authenticated/documents/index.tsx",
      "parent": "/_authenticated/documents"
    },
    "/_authenticated/kiosk/": {
      "filePath": "_authenticated/kiosk/index.tsx",
      "parent": "/_authenticated/kiosk"
    },
    "/_authenticated/profiles/": {
      "filePath": "_authenticated/profiles/index.tsx",
      "parent": "/_authenticated/profiles"
    },
    "/_authenticated/users/": {
      "filePath": "_authenticated/users/index.tsx",
      "parent": "/_authenticated/users"
    },
    "/_authenticated/collections/edit/$id": {
      "filePath": "_authenticated/collections/edit/$id.tsx",
      "parent": "/_authenticated/collections"
    },
    "/_authenticated/documents/edit/$id": {
      "filePath": "_authenticated/documents/edit/$id.tsx",
      "parent": "/_authenticated/documents"
    },
    "/_authenticated/kiosk/devices/$id": {
      "filePath": "_authenticated/kiosk/devices/$id.tsx",
      "parent": "/_authenticated/kiosk"
    },
    "/_authenticated/kiosk/devices/add": {
      "filePath": "_authenticated/kiosk/devices/add.tsx",
      "parent": "/_authenticated/kiosk"
    },
    "/_authenticated/kiosk/preview/$id": {
      "filePath": "_authenticated/kiosk/preview/$id.tsx",
      "parent": "/_authenticated/kiosk"
    },
    "/_authenticated/kiosk/settings/$id": {
      "filePath": "_authenticated/kiosk/settings/$id.tsx",
      "parent": "/_authenticated/kiosk"
    },
    "/_authenticated/kiosk/settings/add": {
      "filePath": "_authenticated/kiosk/settings/add.tsx",
      "parent": "/_authenticated/kiosk"
    },
    "/_authenticated/profiles/edit/$id": {
      "filePath": "_authenticated/profiles/edit/$id.tsx",
      "parent": "/_authenticated/profiles"
    },
    "/_authenticated/users/edit/$id": {
      "filePath": "_authenticated/users/edit/$id.tsx",
      "parent": "/_authenticated/users"
    },
    "/_authenticated/kiosk/devices/": {
      "filePath": "_authenticated/kiosk/devices/index.tsx",
      "parent": "/_authenticated/kiosk"
    },
    "/_authenticated/kiosk/settings/": {
      "filePath": "_authenticated/kiosk/settings/index.tsx",
      "parent": "/_authenticated/kiosk"
    },
    "/_authenticated/kiosk/devices/edit/$id": {
      "filePath": "_authenticated/kiosk/devices/edit/$id.tsx",
      "parent": "/_authenticated/kiosk"
    },
    "/_authenticated/kiosk/settings/edit/$id": {
      "filePath": "_authenticated/kiosk/settings/edit/$id.tsx",
      "parent": "/_authenticated/kiosk"
    }
  }
}
ROUTE_MANIFEST_END */
